<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
    @import './assets/css/vendor/animate/animate.min.css';
    @import "./assets/css/main_conjurer.css";
    @import "./assets/css/ikea-fundament-icons.css";
    @import "./assets/css/ikea-fundament-icons-v2.css";
    // @import "./assets/css/ikea-icons.css";
    @import "./assets/css/buttons.css";
    @import "./assets/css/sidenav.css";
    @import "./assets/css/itemInfo.css";
    @import "./assets/css/itemInfo_Template.css";
    @import "./assets/css/prices.css";
    @import "./assets/css/template_item_block.css";
    @import "./assets/css/template_item_selector.css";
    @import "./assets/css/template_item_versions.css";
    @import './assets/css/slick.css';
    @import './assets/css/sliderMain.css';
    @import './assets/css/slick-theme-custom.css';
    
    @import './assets/scss/polygon.scss';
    @import './assets/scss/catalog.scss';
    @import './assets/scss/loading.scss';
    //@import "./assets/css/main.css";
</style>
